module.exports = __webpack_public_path__ + "static/media/blog4_2.c7b7b9e1.webp";